import { sink } from './sink'

export class ExclusiveLock<T extends string> {
  private state: { type: T; promise: Promise<any>; abortController: AbortController; stack: DisposableStack } | null = null

  get type() {
    return this.state?.type || null
  }

  get promise() {
    return this.state?.promise || null
  }

  run<R>(type: T, init: (ab: AbortController, stack: DisposableStack) => Promise<R>) {
    if (this.state?.type === type) return this.state.promise as Promise<R>
    if (this.state) {
      this.state.abortController.abort()
      this.state.stack.dispose()
    }
    const ab = new AbortController()
    const stack = new DisposableStack()
    const p = init(ab, stack)
    sink(p)
    this.state = {
      type,
      promise: p,
      abortController: ab,
      stack,
    }
    return p
  }

  abort(reason: string) {
    if (this.state) {
      this.state.abortController.abort(reason)
      this.state.stack.dispose()
      this.state = null
    }
  }
}
